import SocialEntityRepository from '@/shared/http/repositories/socialProject/social-entity'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import Pagination from '@/components/layout/Pagination/pagination.vue'
import Search from '@/components/layout/Search/search.vue'
import fab from 'vue-fab'
import Roles from '@/shared/mixins/hasRoles'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'EntidadeSocial',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [Pagination.name]: Pagination,
    [Search.name]: Search,
    fab
  },

  mixins: [Roles],

  data: () => ({
    socialEntities: [],
    labelSearch: 'Entidades Sociais',
    showModalSocialEntity: false,
    id: null,
    searchText: null,
    fields: [
      {
        key: 'name',
        label: 'ENTIDADE SOCIAL',
        class: 'left-header-border text-center'
      },
      {
        key: 'action',
        label: 'AÇÕES',
        class: 'right-header-border text-center'
      }
    ],
    pagination: {
      count: 1,
      limit: 10,
      index: 1
    }
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Entidades Sociais',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getAll()
  },

  methods: {
    getAll() {
      loading.push()
      SocialEntityRepository.GetAll(this.searchText, this.pagination)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.socialEntities = res.data.data
          this.pagination = {
            count: res.data.count,
            limit: res.data.pagingLimit,
            index: res.data.pagingIndex
          }
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar entidade social', 'ERRO')
        })
    },

    search(searchText) {
      this.searchText = searchText
      this.getAll()
    },

    onDelete() {
      loading.push()
      SocialEntityRepository.Delete(this.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.getAll()
          this.showModalSocialEntity = false
          toast.success('Entidade Social excluída com sucesso!', 'EXCLUSÃO DA ENTIDADE SOCIAL')
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao excluir entidade social', 'ERRO')
        })
    },

    selectRow(id) {
      this.showModalSocialEntity = true
      this.id = id
    }
  }
}
